import { updateObject } from 'store/utility';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    timeLineLength: 0,
	leftMarkerPosition: 0,
	rightMarkerPosition: 100,
	leftMarkerTimeframe: null,
	rightMarkerTimeframe: null,
	leftMarkerSeconds: null,
	rightMarkerSeconds: null
}

const CutReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.CUT_SET_TIMELINE_LENGTH:
            return updateObject(state, { timeLineLength: action.length });
        case actionTypes.CUT_SET_LEFT_MARKER:
            return updateObject(state, { ...action.data });
        case actionTypes.CUT_SET_RIGHT_MARKER:
            return updateObject(state, { ...action.data });
        case actionTypes.CUT_RESET:
            return updateObject(state, { ...INITIAL_STATE });
        default:
            return state;
    }
}

export default CutReducer;
